import { stringify } from 'qs';
import appInfoList from '../config/appInfoList.js';

/**
 * 获取子系统跳转链接
 * @param {Object} appInfo 当前选择的子系统 (app)
 * @param {Object} candidate 所有候选参数
 * @returns {String} 跳转链接
 */
export default function getPath(appInfo, candidate) {
  const { code: appCode, address } = appInfo
  const { port, entryPath, query } = getTargetItem(appCode)
  let quertString = ''
  if (query) {
    quertString = getQueryString(query, candidate)
  }
  if (process.env.NODE_ENV === 'development') {
    return getEnvPath(port, address, entryPath, quertString);
  } else if (process.env.NODE_ENV === 'production') {
    if (appInfo.code === 'fs') {
      return getProdPath(address, entryPath, quertString);
    } else {
      return getEnvPath(port, address, entryPath, quertString);
    }
  }
};

function getTargetItem(code) {
  return appInfoList.find(item => item.code === code || item.code === 'default');
};
/**
 * 拼接参数字符串
 * @param {Object} targetQuery 当前跳转的子系统 (app)需要的参数字段对象
 * @param {Object} candidate 候选参数对象
 * @returns {String} 拼接完成的参数字符串
 */
function getQueryString(targetQuery, candidate) {
  const query = {}
  for (const key in targetQuery) {
    if (Object.hasOwnProperty.call(targetQuery, key)) {
      const value = targetQuery[key];
      if (value) {
        query[key] = candidate[key];
      }
    }
  }
  return stringify(query);
}

function getEnvPath(port, address, entryPath, quertString) {
  const { protocol, hostname } = window.location;
  var userInfo=window.localStorage.getItem('userInfo');
  var adminType=JSON.parse(userInfo).adminType;
  if (port) {
    return window.location.hostname === '192.168.1.101' ? `${protocol}//192.168.1.101:8070${entryPath}?${quertString}` : `${protocol}//${hostname}:8071${entryPath}?${quertString}`
    // if (address.includes('192.168.0')) {
    //   return `${protocol}//${hostname}:${port}${entryPath}?${quertString}`
    // }
    // else {
    //   if(adminType===3){
    //     return `${address}?${quertString}`;//针对开发环境跳转外部地址
    //   }else{
    //     return `${protocol}//${hostname}:${port}${entryPath}?${quertString}`
    //   }
    // }
  } else {
    return `${address}?${quertString}`; // 针对盐边 OA 开发环境
  }
};

function getProdPath(address, entryPath, quertString) {
  const { protocol } = window.location;
  return `${protocol}//${address}${entryPath}?${quertString}`
  //钒钛园区
  // return `http://36.137.140.99:8070${entryPath}?${quertString}`
};
